import get from 'lodash/get';
import capitalize from 'lodash/capitalize';

import {
  FETCH_LISTING_REJECTED,
  FETCH_LISTING_FULFILLED,
  FETCH_LISTING_PENDING,
  FETCH_LISTING_ABORT,
  LOAD_MORE_ITEMS_REJECTED,
  LOAD_MORE_ITEMS_FULFILLED,
  LOAD_MORE_ITEMS_PENDING,
  REMOVE_LISTING_FULFILLED,
  LISTING_TYPES,
  SET_CURRENT_LIST_TYPE,
  SET_UPDATED_LISTING_PRICE,
} from '../constants';

const getListingType = ({ meta: { listType } }) => `data${capitalize(listType)}`;
const getArrayProp = ({ meta: { listType } }) => (listType === LISTING_TYPES.sales ? 'sales' : 'listings');

export const defaultState = {
  dataActive: {
    listings: [],
    paging: {
      hasNext: false,
      _links: {
        loadMore: null,
      },
    },
  },
  dataSales: {
    sales: [],
    paging: {
      hasNext: false,
      _links: {
        loadMore: null,
      },
    },
  },
  dataExpired: {
    listings: [],
    paging: {
      hasNext: false,
      _links: {
        loadMore: null,
      },
    },
  },
  dataUnsold: {
    listings: [],
    paging: {
      hasNext: false,
      _links: {
        loadMore: null,
      },
    },
  },
  isLoadingMore: false,
  fetched: false,
  fetching: false,
  currentListType: '',
};

const ticketListingsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case REMOVE_LISTING_FULFILLED: {
      const removedListingId = get(action, 'payload.body.listingId');

      if (!removedListingId) {
        return state;
      }

      return {
        ...state,
        dataActive: {
          ...state.dataActive,
          listings: state.dataActive.listings.filter(data => data.id !== removedListingId),
        },
      };
    }

    case FETCH_LISTING_PENDING:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_LISTING_FULFILLED: {
      return {
        ...state,
        [getListingType(action)]: action.payload.body,
        fetched: true,
        fetching: false,
      };
    }

    case FETCH_LISTING_REJECTED:
      return {
        ...state,
        error: action.payload,
        fetched: false,
        fetching: false,
      };

    case FETCH_LISTING_ABORT:
      return {
        ...state,
        isLoadingMore: false,
        fetching: false,
      };

    case LOAD_MORE_ITEMS_PENDING:
      return {
        ...state,
        isLoadingMore: true,
      };

    case LOAD_MORE_ITEMS_FULFILLED: {
      const data = action.payload.body;
      const listType = getListingType(action);
      const listingArray = getArrayProp(action);

      return {
        ...state,
        [listType]: {
          ...state[listType],
          [listingArray]: [
            ...state[listType][listingArray],
            ...data[listingArray],
          ],
          paging: data.paging,
        },
        isLoadingMore: false,
      };
    }

    case LOAD_MORE_ITEMS_REJECTED:
      // const listType = getListingType(action);
      return {
        ...state,
        isLoadingMore: false,
      };

    case SET_CURRENT_LIST_TYPE:
      return {
        ...state,
        currentListType: action.payload,
      };

    case SET_UPDATED_LISTING_PRICE: {
      const { payload: { listingId, pendingPrice } } = action;
      const listType = getListingType(action);
      const listProp = getArrayProp(action);
      const data = state[listType];
      let list = data[listProp];

      list = list.map((item) => {
        if (item.id === listingId) {
          return {
            ...item,
            pendingPrice,
          };
        }

        return item;
      });

      return {
        ...state,
        [listType]: {
          ...data,
          [listProp]: [
            ...list,
          ],
        },
      };
    }
    default:
      return state;
  }
};

export default ticketListingsReducer;
